import I18nUtil from '@didi/i18n-util';
const { getRegion, CountryMap } = I18nUtil;
const country = CountryMap.includes(getRegion())? getRegion():'' 

export const getCountry = country || JSON.parse(window?.localStorage?.getItem('countryCode')) || 'MX'